import React from "react";
import { Link } from "react-router-dom";
import { FaStethoscope } from "react-icons/fa";
import { GiBrokenHeartZone } from "react-icons/gi";

function ErrorPage() {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-200">
      <div className="relative max-w-lg p-10 bg-white rounded-lg shadow-lg text-center">
        <div className="mb-8 flex justify-center">
          <GiBrokenHeartZone className="inline text-red-500 text-9xl" />
        </div>

        <div className="text-gray-700">
          <h1 className="text-4xl font-bold mb-4">Oops! Page Not Found </h1>
          <p className="mb-6 text-lg">
            It looks like the page you are looking for is not available in our
            hospital management system.
          </p>
        </div>

        <div className="mt-6">
          <button className="relative inline-block text-lg font-semibold text-white bg-primary px-6 py-3 rounded-md hover:bg-darksecondary transition">
            <Link to="/" className="flex items-center">
              <FaStethoscope className="mr-2" /> Go Home
            </Link>
          </button>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage;
